"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = normalize;
exports.matchRank = matchRank;
exports.searchRows = searchRows;
exports.collectTargets = collectTargets;
function normalize(value) {
    return value.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
}
function startsAWord(haystack, needle) {
    return haystack.split(/[^\p{L}\p{N}]+/u).some((word) => word.startsWith(needle));
}
// Lower is better: a district named like the query, then one whose name has such a word, then a matching code, then a
// place inside the district, then anything that merely contains the query somewhere.
function matchRank(row, needle) {
    const names = [row.title, row.shortTitle].filter((name) => name !== undefined).map(normalize);
    if (names.some((name) => name.startsWith(needle)))
        return { rank: 0 };
    if (names.some((name) => startsAWord(name, needle)))
        return { rank: 1 };
    if (row.code?.toLowerCase().startsWith(needle))
        return { rank: 2 };
    const aliasWord = row.aliases?.find((alias) => startsAWord(normalize(alias), needle));
    if (aliasWord)
        return { rank: 3, matchedAlias: aliasWord };
    if (names.some((name) => name.includes(needle)))
        return { rank: 4 };
    const aliasInside = row.aliases?.find((alias) => normalize(alias).includes(needle));
    if (aliasInside)
        return { rank: 4, matchedAlias: aliasInside };
    return undefined;
}
function flatten(rows, parentTitle) {
    return rows.flatMap((row) => [{ ...row, children: undefined, parentTitle }, ...flatten(row.children ?? [], row.title)]);
}
function searchRows(sections, query) {
    const needle = normalize(query.trim());
    if (!needle)
        return [];
    const ranked = flatten(sections.flatMap((section) => section.rows)).flatMap((row) => {
        const match = matchRank(row, needle);
        return match ? [{ row: { ...row, matchedAlias: match.matchedAlias }, rank: match.rank }] : [];
    });
    return ranked.sort((a, b) => a.rank - b.rank).map((entry) => entry.row);
}
function collectTargets(rows, into) {
    for (const row of rows) {
        if (row.href)
            into.push(row.href);
        if (row.children)
            collectTargets(row.children, into);
    }
}
